import { RouteRecordRaw } from "vue-router";
import { AuthGuardService } from "@/_guard/AuthGuardService";

const auth = new AuthGuardService();

export const DashboardRoutes: RouteRecordRaw[] = [
  {
      path: '/dashboard',
      alias: ['/'],
      name: "viewDashboard",
      meta: {title: 'Dashboard'},
      component: () => import('@/modules/dashboard/views/viewDashboard.vue'),
      beforeEnter: auth.guard,
  }
];
